import bakerybiscuits from "../images/bakery-biscuits.png";
import teacoffeedrinks from "../images/tea-coffee-drinks.png";
import dairybreadeggs from "../images/dairy-bread-eggs.png";
import attaricedal from "../images/atta-rice-dal.png";
import fruitsvegetables from "../images/fruits-vegetables.png";
import productMain from "../images/almoune/hallab-baklava.jpg";
import { deliveryRules, getProductPriceLabel, loadCatalog, getProductBusinessUnit } from "./catalog";
import { isAntiGaspiActive, getAntiGaspiPrice, formatEur } from "./antiGaspi";

const pickImage = (product) => {
  const catStr = Array.isArray(product.category) ? product.category.join(" ") : (product.category || "");
  const source = `${catStr} ${product.name} ${product.type}`.toLowerCase();

  if (source.includes("boisson") || source.includes("cafe")) {
    return teacoffeedrinks;
  }
  if (
    source.includes("lait") ||
    source.includes("labneh") ||
    source.includes("fromage")
  ) {
    return dairybreadeggs;
  }
  if (
    source.includes("condiment") ||
    source.includes("zaatar") ||
    source.includes("tahini")
  ) {
    return attaricedal;
  }
  if (source.includes("pain") || source.includes("aperitif")) {
    return fruitsvegetables;
  }
  if (source.includes("baklava") || source.includes("hallab")) {
    return productMain;
  }
  return bakerybiscuits;
};

export const getProductImageFallback = (product) => pickImage(product);

const badgeForProduct = (product) => {
  if (isAntiGaspiActive(product)) {
    return `Anti-gaspi -${Number(product.antiGaspiDiscount || 0)}%`;
  }
  if (product.featured) {
    return "Selection";
  }
  if (product.stock <= 0) {
    return "Rupture";
  }
  if (product.stock <= 10) {
    return "Stock faible";
  }
  if (product.type === "fresh") {
    return "Frais";
  }
  if (product.type === "frozen") {
    return "Surgele";
  }
  return "Disponible";
};

export const loadStorefrontProducts = async () => {
  const catalog = await loadCatalog();
  const shopProducts = catalog.filter((product) => getProductBusinessUnit(product) === "alimentation");

  return shopProducts.map((product, index) => {
    const antiGaspiPrice = getAntiGaspiPrice(product);
    return {
      ...product,
      image: pickImage(product),
      badge: badgeForProduct(product),
      priceLabel: formatEur(product.price),
      unitLabel: getProductPriceLabel(product),
      rating: "4.6",
      reviews: 30 + index * 7,
      antiGaspiPrice,
      antiGaspiPriceLabel: antiGaspiPrice !== null ? formatEur(antiGaspiPrice) : null,
      originalPriceLabel: antiGaspiPrice !== null ? formatEur(product.price) : null,
    };
  });
};

export const loadFeaturedStorefrontProducts = async (limit = 10) =>
  (await loadStorefrontProducts())
    .sort((a, b) => Number(b.featured) - Number(a.featured))
    .slice(0, limit);

export const loadPrimaryStorefrontProduct = async () =>
  (await loadFeaturedStorefrontProducts(1))[0] || null;

export const loadRelatedStorefrontProducts = async (limit = 4, excludeId = "") =>
  (await loadStorefrontProducts())
    .filter((product) => product.id !== excludeId)
    .slice(0, limit);

export const getDeliveryRuleLabel = (type) =>
  deliveryRules[type] || deliveryRules.regular;
